import { render } from "./vhpBreadcrumb.vue?vue&type=template&id=bde491a0"
import script from "./vhpBreadcrumb.vue?vue&type=script&lang=js"
export * from "./vhpBreadcrumb.vue?vue&type=script&lang=js"

import "./vhpBreadcrumb.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__